import { Reader, Writer } from "protobufjs/minimal";
import type { TargetGroup } from "../../../aysa_api/shared/v1/target_group.types";

export const decodeTargetGroup = (reader: Reader): TargetGroup => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    default:
      return 0;
  }
};

export const encodeTargetGroup = (
  writer: Writer,
  value: TargetGroup
): Writer => {
  return writer.int32(value);
};
